import { Point } from 'components/site/general/singleSelect/SelectedMarkerV2/Point';
import { RefObject, useEffect, useState } from 'react';
import { ICoordinates } from 'react-give-me-map';
import { IXY } from 'react-give-me-map/dist/utils/map/mapTypes';
import { MapRef } from 'react-map-gl';
import { useUpdateEffect } from 'usehooks-ts';

interface Props {
    mapRef: RefObject<MapRef>;
    coordinates: ICoordinates[];
    pointsToShow: 'first' | 'all';
    pointsVisible: boolean;
    onPointClicked: (coordinate: ICoordinates, isLast: boolean) => void;
}

export const Points = (props: Props) => {
    const { mapRef } = props;
    const coordinates =
        props.pointsToShow === 'all' ? props.coordinates : props.coordinates.slice(0, 1);

    function getInitialXyCoordinates(): IXY[] {
        return coordinates.map((c) => mapRef.current?.project([c.lng, c.lat]));
    }

    const [xyCoordinates, setXyCoordinates] = useState(() => getInitialXyCoordinates());
    useEffect(() => {
        const listener = () => {
            setXyCoordinates(getInitialXyCoordinates());
        };
        mapRef.current?.on('move', listener);
        return () => {
            mapRef.current?.off('move', listener);
        };
    });
    useUpdateEffect(() => {
        setXyCoordinates(getInitialXyCoordinates());
    }, [coordinates.length]);

    if (!props.pointsVisible) {
        return null;
    }

    return (
        <>
            {xyCoordinates.map((xyCoordinate, index) => {
                const id = xyCoordinate.x + '|' + xyCoordinate.y;
                return (
                    <div
                        key={id}
                        style={{
                            position: 'absolute',
                            left: xyCoordinate.x,
                            top: xyCoordinate.y,
                            display: 'inline-block'
                        }}
                        onClick={() => {
                            const isLast = index === coordinates.length - 1;
                            const coordinate = mapRef.current.unproject([
                                xyCoordinate.x,
                                xyCoordinate.y
                            ]);
                            const pointCoordinate = {
                                lat: coordinate.lat,
                                lng: coordinate.lng
                            };
                            props.onPointClicked(pointCoordinate, isLast);
                        }}
                    >
                        <Point
                            className={'handle'}
                            width={16}
                            fontSize={12}
                            style={{ pointerEvents: 'all' }}
                            text={''}
                            color={'white'}
                        />
                    </div>
                );
            })}
        </>
    );
};
